import config from "../../utils/config";

const ORIGIN = window.location.origin;
const BASENAME = process.env.PUBLIC_URL || "";
const OKTA_TESTING_DISABLE_HTTPSCHECK =
  process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;

export default {
  // INTERNAL Okta
  oidc: {
    clientId: config.CLIENT_ID,
    issuer: "https://emerson.okta.com/oauth2/default",
    redirectUri: `${ORIGIN}${BASENAME}/oidc/callback`,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLE_HTTPSCHECK,
    tokenManager: {
      expireEarlySeconds: 30 * 60,
    },
  },

  // EXTERNAL Okta (accessemr)
  ip_oidc: {
    clientId: "0oadjg350yRGK4rtD1t7",
    issuer: "https://accessemr.okta.com/oauth2/default",
    redirectUri: `${ORIGIN}/sso/callback`,
    scopes: ["openid", "profile", "email"],
    responseType: ["id_token", "token"],
    pkce: false,
    disableHttpsCheck: OKTA_TESTING_DISABLE_HTTPSCHECK,
    tokenManager: {
      expireEarlySeconds: 30 * 60,
    },
  },

  resourceServer: {
    messagesUrl: `${ORIGIN}/api/messages`,
  },

  app: {
    basename: BASENAME,
  },
};
